export default function TexasAcceptanceFacilitiesSection() {
  const facilities = [
    {
      name: "Houston Main Post Office",
      address: "401 Franklin St, Houston, TX 77201",
      hours: "Mon–Fri 8:30 AM – 5:00 PM (appointment required)",
      phone: "(713) 226-3102",
      website: "https://tools.usps.com/rcas.htm",
      notes: "Downtown Houston's primary passport acceptance facility. Photo services available on-site. Busiest facility in Harris County — book 2–3 weeks in advance during peak travel seasons.",
      region: "Houston Metro",
    },
    {
      name: "Dallas Main Post Office",
      address: "400 N Ervay St, Dallas, TX 75201",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(214) 760-4536",
      website: "https://tools.usps.com/rcas.htm",
      notes: "Downtown Dallas passport acceptance hub. Photo services available. Servicing the central Dallas area including Uptown, Deep Ellum, and Oak Lawn neighborhoods.",
      region: "DFW Metroplex",
    },
    {
      name: "Austin Main Post Office",
      address: "8225 Cross Park Dr, Austin, TX 78710",
      hours: "Mon–Fri 8:30 AM – 5:00 PM (appointment required)",
      phone: "(512) 342-1295",
      website: "https://tools.usps.com/rcas.htm",
      notes: "Primary passport acceptance facility for Travis County. Photo services available. High demand from UT students and faculty — appointments fill quickly before semester breaks.",
      region: "Central Texas",
    },
    {
      name: "San Antonio Main Post Office",
      address: "10410 Perrin Beitel Rd, San Antonio, TX 78284",
      hours: "Mon–Fri 8:30 AM – 5:30 PM, walk-ins available on limited basis",
      phone: "(210) 368-2550",
      website: "https://tools.usps.com/rcas.htm",
      notes: "Largest passport acceptance facility in South Texas. Walk-in capacity limited — arrive before 9:00 AM for best availability. Photo services on-site.",
      region: "South Texas",
    },
    {
      name: "Fort Worth Main Post Office",
      address: "4600 Mark IV Pkwy, Fort Worth, TX 76161",
      hours: "Mon–Fri 8:30 AM – 5:00 PM (appointment required)",
      phone: "(817) 740-3585",
      website: "https://tools.usps.com/rcas.htm",
      notes: "Primary passport acceptance facility for Tarrant County. Serves Fort Worth, Arlington, and Mid-Cities area. Passport photos available — no appointment needed for photos only.",
      region: "DFW Metroplex",
    },
    {
      name: "El Paso Main Post Office",
      address: "8401 Boeing Dr, El Paso, TX 79910",
      hours: "Mon–Fri 8:30 AM – 5:00 PM (appointment required)",
      phone: "(915) 775-4208",
      website: "https://tools.usps.com/rcas.htm",
      notes: "Westernmost Texas passport acceptance facility serving El Paso County and Fort Bliss military community. Photo services available. Bilingual staff.",
      region: "West Texas",
    },
    {
      name: "Collin County Clerk — McKinney",
      address: "2300 Bloomdale Rd, McKinney, TX 75071",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      phone: "(972) 548-4185",
      website: "https://www.collincountytx.gov/county_clerk/Pages/passports.aspx",
      notes: "Primary acceptance facility for Collin County — serves Plano, Frisco, Allen, McKinney. Appointment recommended. No photo services — bring your own passport photos.",
      region: "DFW Metroplex",
    },
    {
      name: "Bexar County District Clerk",
      address: "300 Dolorosa St, San Antonio, TX 78205",
      hours: "Mon–Fri 8:00 AM – 4:30 PM",
      phone: "(210) 335-2238",
      website: "https://www.bexar.org/2238/Passports",
      notes: "County-operated passport acceptance office in downtown San Antonio. Appointment required. No photo services on-site. Serves all Bexar County including military communities at JBSA.",
      region: "South Texas",
    },
  ];

  return (
    <section id="facilities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Passport Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where to Submit a New Passport in Texas
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            First-time applicants — and most applicants who are not eligible for a standard mail-in renewal — must apply in person at a passport acceptance clerk. Texas has hundreds of acceptance facilities across post offices, county clerk offices, and public libraries. Below are key facilities in major Texas metro areas. All locations require an appointment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
          {facilities.map((f, i) => (
            <div key={i} className="bg-white rounded-lg p-6 border border-gray-200">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
                  <i className="ri-map-pin-2-line text-[#1A365D] text-base"></i>
                </div>
                <div>
                  <div className="flex items-center gap-2 mb-0.5">
                    <h3 className="font-bold text-[#1A365D] text-sm">{f.name}</h3>
                    <span className="text-xs font-medium text-gray-400 bg-gray-100 px-2 py-0.5 rounded-full whitespace-nowrap">{f.region}</span>
                  </div>
                  <p className="text-gray-500 text-xs mt-0.5">{f.address}</p>
                </div>
              </div>
              <div className="space-y-1.5 text-xs text-gray-500 ml-12">
                <p><i className="ri-time-line text-[#F6C344] mr-1"></i>{f.hours}</p>
                <p><i className="ri-phone-line text-[#F6C344] mr-1"></i>{f.phone}</p>
                <p>
                  <i className="ri-global-line text-[#F6C344] mr-1"></i>
                  <a href={f.website} target="_blank" rel="nofollow noopener noreferrer" className="text-[#1A365D] hover:text-[#F6C344] underline transition-colors">
                    Visit website
                  </a>
                </p>
              </div>
              <div className="mt-3 ml-12 bg-[#F7F8FA] rounded-md p-3 border border-gray-100">
                <p className="text-gray-500 text-xs leading-relaxed">{f.notes}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#1A365D] rounded-lg p-6 flex flex-col md:flex-row items-center gap-5 text-center md:text-left">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
            <i className="ri-lightbulb-line text-[#1A365D] text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="text-white font-bold text-base mb-1">How This Works With Fast Passport Center</p>
            <p className="text-white/60 text-sm leading-relaxed">
              If you plan to use a registered courier service to speed up your passport, you must sign up with us <strong className="text-white">before</strong> visiting the acceptance clerk. If you go to the clerk first without a courier arrangement, the clerk will submit your application through the standard postal mail route — and once that happens, we cannot intervene or take over the process. Secure your courier service now, then visit the clerk prepared.
            </p>
          </div>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0"
          >
            Start Now <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>

        <p className="text-center text-gray-400 text-xs mt-8">
          Select your city page for a complete list of acceptance facilities in your area. Each city page lists the nearest post offices, county clerk offices, and libraries that accept passport applications.
        </p>
      </div>
    </section>
  );
}